<div
  class="sia-side-panel sia-side-panel-background"
  [class]="visible ? 'visible' : ''"
  [attr.inert]="!visible ? '' : null"
  (clickedOutside)="closePanel()"
  [outsideClickActive]="visible && !previewVisible()"
  [clickTimeout]="500"
  outsideClick
>
  <div class="flex items-center justify-between" #filterHeader>
    <span class="text-secondary text-2xl">{{
      'Pannello file' | siaTranslate
    }}</span>
    <button mat-icon-button (click)="closePanel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  @if (archives.length > 1) {
    <sia-select-box
      label="ARCHIVI"
      [selectBoxOptions]="{
        fixedDataSource: archivesDataSource,
        value: selectedArchive?.id,
        disableEmptyElement: true,
        autoSelectFirst: true,
      }"
      (valueChanged)="selectedArchiveChanged($event)"
      [value]="selectedArchive?.id"
      #selectBoxArchivesEl
    ></sia-select-box>
  }

  <sia-core-file-system
    [originalPath]="path"
    [path]="path"
    [pathDescription]="selectedArchive?.description"
    [showName]="false"
    [showFileTree]="true"
    [compactTreeView]="true"
    [pageData]="pageData"
    (previewVisible)="previewVisible.set($event)"
    class="flex-grow"
    style="height: calc(100% - 112px)"
  ></sia-core-file-system>
</div>
